"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopologicalEditorCollectionEditCtrl = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var modal_service_1 = require("../../components/modal/modal.service");
var notification_service_1 = require("../../components/notification.toast/notification.service");
var theme_1 = require("../../components/theme");
var index_1 = require("../../i18n/index");
var collection_change_state_1 = require("../../modules/collection.view/collection.change.state");
var multi_list_chooser_1 = require("../../modules/multi.list.chooser/multi.list.chooser");
var multi_list_chooser_style_1 = require("../../modules/multi.list.chooser/multi.list.chooser.style");
var span_link_chooser_state_1 = require("../../modules/multi.list.chooser/span.link.chooser.state");
var point_collection_cache_1 = require("../../modules/topological.editor.map/point.collection.cache");
var services_1 = require("../../services");
var collection_edit_state_1 = require("../../state/collection.edit.state");
var mobx_2 = require("../../state/mobx");
var page_state_1 = require("../../state/page.state");
var store_1 = require("../../store");
var upload_reader_1 = require("../../util/upload.reader");
var TopologicalEditorCollectionEditCtrl = /** @class */ (function (_super) {
    tslib_1.__extends(TopologicalEditorCollectionEditCtrl, _super);
    function TopologicalEditorCollectionEditCtrl(collection, parentState) {
        var _this = _super.call(this) || this;
        _this.isFormOpen = mobx_1.observable.map({}, { deep: false });
        _this.isFieldDetailShown = mobx_1.observable.map({}, { deep: false });
        _this.isCollectionLoading = false;
        _this.isCollectionSelected = true;
        _this.isAllExpanded = true;
        _this.isInEditMode = false;
        _this.isSaving = false;
        _this.isMetadataShown = false;
        _this.isZoomShown = true;
        _this.isPhotomeasure = false;
        _this.isTopologicalEditor = true;
        _this.isCarouselShown = true;
        /** File upload */
        _this.maxFileSize = 1000 * 1000 * 10; // 10 Megabyte
        _this.maxImageSize = 1000 * 1000 * 4; // 4 Megabyte
        _this.allowedTypes = [];
        _this.isInUploadMode = false;
        _this.fieldsInLoadingState = [];
        _this.file = null;
        _this.image = null;
        _this.kind = 'TopologicalEditorCollectionEditCtrl';
        _this.collectionEditState = new collection_edit_state_1.CollectionEditState(collection);
        _this.changeState = new collection_change_state_1.CollectionChangeState();
        _this.parentState = parentState;
        _this.reaction(function (_) { return _this.file && _this.file.buffer; }, _this.processFile);
        _this.reaction(function (_) { return _this.image && _this.image.buffer; }, _this.processImage);
        return _this;
    }
    Object.defineProperty(TopologicalEditorCollectionEditCtrl.prototype, "collection", {
        get: function () {
            return this.collectionEditState.collection;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorCollectionEditCtrl.prototype, "revision", {
        get: function () {
            return this.collection.revision;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorCollectionEditCtrl.prototype, "id", {
        get: function () {
            return this.collection.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorCollectionEditCtrl.prototype, "isEditing", {
        get: function () {
            return this.changeState != null && (this.isInEditMode || this.isPhotomeasure || this.isTopologicalEditor);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorCollectionEditCtrl.prototype, "isValid", {
        get: function () {
            return this.changeState != null && this.changeState.isValid && !this.isInUploadMode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorCollectionEditCtrl.prototype, "isEditable", {
        get: function () {
            return services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_MAP_MODE);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TopologicalEditorCollectionEditCtrl.prototype, "isUploading", {
        get: function () {
            return this.changeState != null && this.isInUploadMode;
        },
        enumerable: false,
        configurable: true
    });
    TopologicalEditorCollectionEditCtrl.prototype.zoomToCollection = function () {
        //TODO: add zoom to collection
    };
    TopologicalEditorCollectionEditCtrl.prototype.clearOpenState = function () {
        this.isFormOpen.clear();
        this.isFieldDetailShown.clear();
    };
    TopologicalEditorCollectionEditCtrl.prototype.abortChanges = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var shouldDiscard, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        shouldDiscard = false;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.checkAndDiscardChanges()];
                    case 2:
                        shouldDiscard = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        services_1.Services.Log.Logger.error(error_1, 'TE: Discard changes failed');
                        notification_service_1.NotificationService.error({
                            key: index_1.T.ERROR_GENERAL
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        if (shouldDiscard && this.changeState != null) {
                            this.discardAndDestroyEdit();
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    TopologicalEditorCollectionEditCtrl.prototype.selectAnchorField = function (e, field) {
        e.preventDefault();
        services_1.Services.Log.Logger.warn("1. Anchor is edit by user ".concat(services_1.Services.User.current.email.toString(), " in department ").concat(services_1.Services.Department.current.name.toString(), " of organization ").concat(services_1.Services.Department.currentOrg.name.toString()));
    };
    TopologicalEditorCollectionEditCtrl.prototype.checkAndDiscardChanges = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, modal_service_1.ModalService.open({
                            title: index_1.T.DISCARD_CHANGES_TITLE,
                            content: (0, index_1.Translate)(index_1.T.DISCARD_CHANGES_CONFIRM),
                            okName: index_1.T.DISCARD_CHANGES_DISCARD,
                            hasCancel: true
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.ok];
                }
            });
        });
    };
    TopologicalEditorCollectionEditCtrl.prototype.discardAndDestroyEdit = function () {
        if (this.changeState != null) {
            //discard everything
            while (this.collectionEditState.isDirty) {
                this.collectionEditState.reset();
            }
        }
        this.changeState = new collection_change_state_1.CollectionChangeState();
        this.isInEditMode = false;
        point_collection_cache_1.TopologicalPointCollectionCache.dropCollectionLocations(this.revision);
        point_collection_cache_1.TopologicalPointCollectionCache.flushVectors();
    };
    TopologicalEditorCollectionEditCtrl.prototype.saveChanges = function (e) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var changes, originalCollection, draw, drawState, result, error_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        changes = this.changeState;
                        if (!changes || !this.changeState.isValid) {
                            return [2 /*return*/];
                        }
                        if (!this.collectionEditState.isDirty) {
                            return [2 /*return*/];
                        }
                        if (this.isSaving) {
                            return [2 /*return*/];
                        }
                        originalCollection = this.collection;
                        draw = this.collectionEditState.currentDraw;
                        drawState = draw != null ? draw.state : null;
                        this.setSaving(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, services_1.Services.Collection.save(originalCollection)];
                    case 2:
                        result = _a.sent();
                        this.collectionCommitted(result, originalCollection, drawState);
                        this.collectionEditState.reset();
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _a.sent();
                        this.setSaving(false);
                        services_1.Services.Log.Logger.error(error_2);
                        notification_service_1.NotificationService.error({
                            key: index_1.T.COLLECTION_EDIT_SAVE_ERROR
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    // This is a specific method for saving a collection as part of a batch edit
    // inside of a "job". It provides minimal error handling and state modification
    // with the expectation that error management and logging will be handled upstream.
    TopologicalEditorCollectionEditCtrl.prototype.batchSaveChanges = function () {
        var _this = this;
        var changes = this.changeState;
        if (!changes ||
            !this.changeState.isValid ||
            !this.collectionEditState.isDirty ||
            this.isSaving) {
            return null;
        }
        var originalCollection = this.collection;
        this.setSaving();
        return services_1.Services.Collection.save(originalCollection)
            .then(function (value) {
            _this.setSaving(false);
            _this.collectionEditState.reset();
            point_collection_cache_1.TopologicalPointCollectionCache.dropCollectionVectors(_this.revision);
            return value;
        })
            .catch(function (error) {
            _this.setSaving(false);
            // Chuck this error upstream to be handled by whatever
            // is calling the batched save
            throw error;
        });
    };
    TopologicalEditorCollectionEditCtrl.prototype.setSaving = function (value) {
        if (value === void 0) { value = true; }
        this.isSaving = value;
    };
    TopologicalEditorCollectionEditCtrl.prototype.collectionCommitted = function (collection, originalCollection, drawState) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, TimingEventType, TimingEventAction;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                _a = services_1.Services.Analytics, TimingEventType = _a.TimingEventType, TimingEventAction = _a.TimingEventAction;
                services_1.Services.Analytics.trackTiming(TimingEventType.TOPOLOGICAL_EDITOR, TimingEventAction.ENTER, originalCollection.id, new Date(this.changeState.startTime));
                services_1.Services.Analytics.trackTiming(TimingEventType.TOPOLOGICAL_EDITOR, TimingEventAction.EXIT, originalCollection.id, new Date());
                this.changeState.startTime = Date.now();
                (0, mobx_1.runInAction)(function () {
                    // PM page will have an IkeDraw. The map page will not.
                    if (_this.collectionEditState.currentDraw != null) {
                        _this.collectionEditState.currentDraw.state.setFromState(drawState);
                    }
                    _this.setSaving(false);
                });
                return [2 /*return*/];
            });
        });
    };
    TopologicalEditorCollectionEditCtrl.prototype.toggleFieldDetail = function (fieldId) {
        if (this.isFieldDetailShown.get(fieldId)) {
            this.isFieldDetailShown.delete(fieldId);
        }
        else {
            this.isFieldDetailShown.set(fieldId, true);
        }
    };
    TopologicalEditorCollectionEditCtrl.prototype.clearModalField = function (field) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response, state;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, modal_service_1.ModalService.open({
                            title: index_1.T.FILE_DELETE_TITLE,
                            content: (0, index_1.Translate)(index_1.T.FILE_DELETE_MESSAGE, field.value),
                            okName: index_1.T.FILE_DELETE,
                            hasCancel: true
                        })];
                    case 1:
                        response = _a.sent();
                        if (response.ok) {
                            field.Mutator.clear();
                            state = this.changeState.getState(field.id);
                            if (state != null) {
                                state.setValue(null);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TopologicalEditorCollectionEditCtrl.prototype.clearField = function (field) {
        field.Mutator.clear();
        if (core_shared_1.CollectionModelFieldVector.isVectorField(field)) {
            point_collection_cache_1.TopologicalPointCollectionCache.dropCollectionVectors(this.revision);
        }
        var state = this.changeState.getState(field.id);
        if (state != null) {
            state.setValue(null);
        }
    };
    TopologicalEditorCollectionEditCtrl.prototype.toggleCarousel = function () {
        this.isCarouselShown = !this.isCarouselShown;
    };
    /**
     * File upload related functions
     */
    TopologicalEditorCollectionEditCtrl.prototype.onDragOver = function (e, field) {
        e.preventDefault();
        var dragArea = document.getElementById("drag-area-".concat(field.id));
        if (dragArea == null) {
            return;
        }
        dragArea.style.backgroundColor = theme_1.DefaultTheme.color.accent;
    };
    TopologicalEditorCollectionEditCtrl.prototype.onDragLeave = function (e, field) {
        e.preventDefault();
        var dragArea = document.getElementById("drag-area-".concat(field.id));
        if (dragArea == null) {
            return;
        }
        dragArea.style.backgroundColor = null;
    };
    TopologicalEditorCollectionEditCtrl.prototype.onDragEnd = function (e, field) {
        e.preventDefault();
        var dragArea = document.getElementById("drag-area-".concat(field.id));
        if (dragArea == null) {
            return;
        }
        dragArea.style.backgroundColor = null;
    };
    TopologicalEditorCollectionEditCtrl.prototype.openImageDialog = function (e, field) {
        e.preventDefault();
        var imageInput = document.getElementById(field.id);
        if (imageInput == null) {
            throw new Error('Unable to find file input: "' + field.id + '\'');
        }
        var evt = document.createEvent('MouseEvents');
        evt.initEvent('click', true, false);
        imageInput.dispatchEvent(evt);
    };
    TopologicalEditorCollectionEditCtrl.prototype.openFileDialog = function (e, field) {
        e.preventDefault();
        var fileInput = document.getElementById(field.id);
        if (fileInput == null) {
            throw new Error('Unable to find file input: "' + field.id + '\'');
        }
        var evt = document.createEvent('MouseEvents');
        evt.initEvent('click', true, false);
        fileInput.dispatchEvent(evt);
    };
    TopologicalEditorCollectionEditCtrl.prototype.onImage = function (e, field) {
        var imageInput = e.target;
        if (imageInput == null) {
            throw new Error("Unable to find file input: \"".concat(field.id, "\""));
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'image:click', 'button', 1);
        this.loadImages(imageInput.files, field);
    };
    TopologicalEditorCollectionEditCtrl.prototype.onFile = function (e, field) {
        var fileInput = e.target;
        if (fileInput == null) {
            throw new Error('Unable to find file input: "' + field.id + '\'');
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:click', 'button', 1);
        this.loadFiles(fileInput.files, field);
    };
    TopologicalEditorCollectionEditCtrl.prototype.update = function (e, field) {
        e.preventDefault();
        if (e.dataTransfer == null) {
            return;
        }
        var files = e.dataTransfer.files;
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:drop', 'drop', 1);
        this.loadFiles(files, field);
    };
    TopologicalEditorCollectionEditCtrl.prototype.loadImages = function (images, field) {
        this.image = null;
        if (images) {
            var image = images[0];
            if (this.maxImageSize < image.size) {
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:large', 'large', image.size);
                notification_service_1.NotificationService.error({ key: index_1.T.FILE_TOO_LARGE });
                this.unsetLoading(field.id);
                return;
            }
            var imageType = image.type.toLowerCase();
            if (this.allowedTypes.length > 0 && imageType !== '' && this.allowedTypes.indexOf(imageType) === -1) {
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'image:type', imageType, 1);
                notification_service_1.NotificationService.error({ key: index_1.T.FILE_NOT_SUPPORTED });
                this.unsetLoading(field.id);
                return;
            }
            this.image = new upload_reader_1.ImageUploadReader(image, field);
        }
    };
    TopologicalEditorCollectionEditCtrl.prototype.loadFiles = function (files, field) {
        this.file = null;
        if (files == null) {
            return;
        }
        if (files.length > 1) {
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:count', String(files.length), 1);
            notification_service_1.NotificationService.error({ key: index_1.T.FILE_NOT_SUPPORTED });
            this.unsetLoading(field.id);
            return;
        }
        for (var i = 0; i < files.length; i++) {
            var file = files[i];
            if (this.maxFileSize < file.size) {
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:large', 'large', file.size);
                notification_service_1.NotificationService.error({ key: index_1.T.FILE_TOO_LARGE });
                this.unsetLoading(field.id);
                continue;
            }
            var fileType = file.type.toLowerCase();
            if (this.allowedTypes.length > 0 && fileType !== '' && this.allowedTypes.indexOf(fileType) === -1) {
                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'file:type', fileType, 1);
                notification_service_1.NotificationService.error({ key: index_1.T.FILE_NOT_SUPPORTED });
                this.unsetLoading(field.id);
                continue;
            }
            this.file = new upload_reader_1.FileUploadReader(file, field);
        }
    };
    TopologicalEditorCollectionEditCtrl.prototype.processFile = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest, attachment, metadata, error_3, e_1;
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!((_a = this.file) === null || _a === void 0 ? void 0 : _a.buffer)) return [3 /*break*/, 9];
                        this.setLoading(this.file.field.id);
                        rest = services_1.Services.Department.rest;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 7, , 8]);
                        return [4 /*yield*/, rest.Attachment.set(this.file.name, this.file.buffer, this.file.type)];
                    case 2:
                        attachment = _b.sent();
                        rest.Attachment.antivirusScan(attachment.objectId);
                        metadata = {};
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, rest.Attachment.parse(attachment.objectId)];
                    case 4:
                        metadata = _b.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        error_3 = _b.sent();
                        services_1.Services.Log.Logger.info("File cannot be parsed: ".concat(error_3));
                        return [3 /*break*/, 6];
                    case 6:
                        this.file.field.Mutator.manual({
                            filename: this.file.name,
                            attachmentId: attachment.objectId,
                            size: attachment.size,
                            metadata: metadata
                        });
                        return [3 /*break*/, 8];
                    case 7:
                        e_1 = _b.sent();
                        notification_service_1.NotificationService.error({ key: index_1.T.ERROR_GENERAL });
                        return [3 /*break*/, 8];
                    case 8:
                        this.unsetLoading(this.file.field.id);
                        _b.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    TopologicalEditorCollectionEditCtrl.prototype.processImage = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var rest, capture, e_2;
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!((_a = this.image) === null || _a === void 0 ? void 0 : _a.buffer)) return [3 /*break*/, 5];
                        this.setLoading(this.image.field.id);
                        rest = services_1.Services.Department.rest;
                        capture = null;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, rest.Capture.Image.image(core_shared_1.IkeId.v4(), this.image.buffer, 1, new Date())];
                    case 2:
                        capture = _b.sent();
                        rest.Capture.antivirus({ captureId: capture.objectId });
                        this.image.field.Mutator.add(capture.objectId);
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _b.sent();
                        notification_service_1.NotificationService.error({ key: index_1.T.ERROR_GENERAL });
                        services_1.Services.Log.Logger.info("Image cannot be parsed: ".concat(e_2));
                        return [3 /*break*/, 4];
                    case 4:
                        this.unsetLoading(this.image.field.id);
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    TopologicalEditorCollectionEditCtrl.prototype.fileDownload = function (field) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var token, url, options;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                if (field.attachmentId) {
                    this.setLoading(field.id);
                    token = "Bearer ".concat(services_1.Services.SSO.token);
                    url = '/v1/file/' + field.attachmentId + '?departmentId=' + services_1.Services.Department.current.objectId;
                    options = {
                        headers: {
                            Authorization: token
                        }
                    };
                    fetch(url, options)
                        .then(function (res) {
                        if (!res.ok) {
                            services_1.Services.Log.Logger.error('File possibly infected');
                            notification_service_1.NotificationService.error({
                                key: index_1.T.ERROR_DOWNLOAD_FAIL
                            });
                            return null;
                        }
                        return res.blob();
                    })
                        .then(function (blob) {
                        if (blob != null) {
                            var file = window.URL.createObjectURL(blob);
                            var link = services_1.Services.Window.document.createElement('a');
                            link.download = field.value;
                            link.href = file;
                            services_1.Services.Window.document.body.appendChild(link);
                            link.click();
                            link.remove();
                        }
                        _this.unsetLoading(field.id);
                    })
                        .catch(function (e) {
                        services_1.Services.Log.Logger.error(e, 'File download error');
                        notification_service_1.NotificationService.error({
                            key: index_1.T.ERROR_GENERAL
                        });
                        _this.unsetLoading(field.id);
                    });
                }
                return [2 /*return*/, false];
            });
        });
    };
    TopologicalEditorCollectionEditCtrl.prototype.setLoading = function (fieldId) {
        this.isInUploadMode = true;
        this.fieldsInLoadingState.push(fieldId);
    };
    TopologicalEditorCollectionEditCtrl.prototype.unsetLoading = function (fieldId) {
        this.isInUploadMode = false;
        this.fieldsInLoadingState.splice(this.fieldsInLoadingState.indexOf(fieldId), 1);
    };
    /**
     * File upload related functions end
     */
    TopologicalEditorCollectionEditCtrl.prototype.fillAddressDisabled = function (field) {
        if (field.value) {
            return true;
        }
        if (this.location() == null) {
            return true;
        }
        if (!this.isEditing || this.isSaving) {
            return true;
        }
        return false;
    };
    TopologicalEditorCollectionEditCtrl.prototype.geocodingButtonTitle = function (field) {
        if (field.value) {
            return 'Already has value';
        }
        if (this.location() == null) {
            return 'There is no location';
        }
        return 'Get address';
    };
    TopologicalEditorCollectionEditCtrl.prototype.location = function () {
        var revision = this.collection.revision;
        var collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
        if (collectionSummary == null) {
            return null;
        }
        var location = collectionSummary.location;
        if (!(location && location.coordinates)) {
            return null;
        }
        return location;
    };
    TopologicalEditorCollectionEditCtrl.prototype.fillAddress = function (field) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var location, addressFields, address, fieldState, metadata, city, state, cityFieldId, cityFieldState, stateFieldId, stateFieldState;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        location = this.location();
                        if (location == null) {
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, services_1.Services.Geocoder.getAddress(location)];
                    case 1:
                        addressFields = _a.sent();
                        address = addressFields.address;
                        fieldState = this.changeState.getState(field.id);
                        fieldState.setValue(address);
                        if (address === (0, index_1.Translate)(index_1.T.ERROR_GENERAL)) {
                            fieldState.setError(address);
                        }
                        metadata = field.collection.schema.metadata;
                        city = addressFields.city;
                        state = addressFields.state;
                        if (city && metadata.options.address_lookup.city) {
                            cityFieldId = metadata.options.address_lookup.city.field;
                            cityFieldState = this.changeState.getState(core_shared_1.CollectionModelField.getStateId(field.parent, cityFieldId));
                            if (cityFieldState) {
                                cityFieldState.setValue(city);
                            }
                        }
                        if (state && metadata.options.address_lookup.state) {
                            stateFieldId = metadata.options.address_lookup.state.field;
                            stateFieldState = this.changeState.getState(core_shared_1.CollectionModelField.getStateId(field.parent, stateFieldId));
                            if (stateFieldState) {
                                stateFieldState.setValue(state);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TopologicalEditorCollectionEditCtrl.prototype.clearError = function (field) {
        var fieldState = this.changeState.getState(field.id);
        fieldState.setValue('');
        fieldState.setError('');
    };
    TopologicalEditorCollectionEditCtrl.prototype.clearErrorDisabled = function (field) {
        if (!this.isEditing || this.isSaving) {
            return true;
        }
        var state = this.changeState.getState(field.id);
        if (state.hasError() === true) {
            return false;
        }
        return true;
    };
    TopologicalEditorCollectionEditCtrl.prototype.isExpanded = function (instanceId) {
        if (this.isAllExpanded) {
            return this.isFormOpen.get(instanceId) !== false;
        }
        return this.isFormOpen.get(instanceId);
    };
    TopologicalEditorCollectionEditCtrl.prototype.toggleExpanded = function (e, instanceId) {
        e.preventDefault();
        var prev = this.isFormOpen.get(instanceId);
        if (prev == null) {
            prev = this.isAllExpanded;
        }
        this.isFormOpen.set(instanceId, !prev);
        return false;
    };
    TopologicalEditorCollectionEditCtrl.prototype.setZoomWindow = function (show) {
        this.isZoomShown = show;
    };
    TopologicalEditorCollectionEditCtrl.prototype.toggleMetaInfo = function () {
        this.isMetadataShown = !this.isMetadataShown;
        this.isZoomShown = false;
    };
    TopologicalEditorCollectionEditCtrl.prototype.toggleZoomWindow = function () {
        this.isZoomShown = !this.isZoomShown;
        this.isMetadataShown = false;
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Collection, "zoom:".concat(this.isZoomShown ? 'show' : 'hide'), this.collection.revision);
    };
    TopologicalEditorCollectionEditCtrl.prototype.toggleExpandAll = function () {
        this.isAllExpanded = !this.isAllExpanded;
        this.isFormOpen.clear();
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Collection, "form:".concat(this.isAllExpanded ? 'expand' : 'collapse'), this.collection.revision);
    };
    TopologicalEditorCollectionEditCtrl.prototype.enterEditMode = function () {
        var collection = this.collection;
        if (collection != null) {
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'Collection:edit', collection.uuid, 1);
        }
        this.isInEditMode = true;
    };
    TopologicalEditorCollectionEditCtrl.prototype.exitEditMode = function () {
        if (this.collectionEditState.isDirty) {
            throw new Error('Must discard changes before exiting collection edit mode');
        }
        this.isInEditMode = false;
    };
    TopologicalEditorCollectionEditCtrl.prototype.beginSpanLink = function (c) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var collection, state, result, spanLinkRecord;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        collection = c.collection;
                        state = new span_link_chooser_state_1.SpanLinkChooserState(collection);
                        return [4 /*yield*/, modal_service_1.ModalService.open({
                                title: multi_list_chooser_1.MultiListChooserTitle.view(state),
                                content: function () { return multi_list_chooser_1.MultiListChooserContent.view(state); },
                                className: multi_list_chooser_style_1.CSS.modal,
                                hasCancel: true
                            })];
                    case 1:
                        result = _a.sent();
                        if (!result.ok) {
                            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'span:link:cancel', this.collection.revision);
                            return [2 /*return*/];
                        }
                        if (state.value == null) {
                            state.selectDefaultValue();
                        }
                        spanLinkRecord = state.getSelectedSpanLinkRecord();
                        if (spanLinkRecord == null) {
                            return [2 /*return*/];
                        }
                        (0, mobx_1.runInAction)(function () {
                            try {
                                var newSubformInstance = services_1.Services.SubFormLink.copySubForm(collection, spanLinkRecord);
                                notification_service_1.NotificationService.success({
                                    key: index_1.T.SPAN_LINK_SUCCESS,
                                    attrs: {
                                        toSpan: newSubformInstance.title,
                                        fromCollection: spanLinkRecord.collection.title
                                    }
                                });
                                services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'span:link', _this.collection.revision);
                            }
                            catch (e) {
                                services_1.Services.Log.Logger.error(e, 'Span link failed');
                                notification_service_1.NotificationService.error({
                                    key: index_1.T.ERROR_GENERAL
                                });
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TopologicalEditorCollectionEditCtrl.prototype, "matches", {
        get: function () {
            if (!services_1.Services.Measurement.isFormSupported(this.collection.schema)) {
                return [];
            }
            return services_1.Services.Measurement.getFieldJoins(this.collection);
        },
        enumerable: false,
        configurable: true
    });
    TopologicalEditorCollectionEditCtrl.prototype.getJoin = function (field) {
        for (var _i = 0, _a = this.matches; _i < _a.length; _i++) {
            var match = _a[_i];
            var join = match.getJoin(field.parent.instanceId, field.schema.id);
            if (join != null) {
                return join;
            }
        }
        return null;
    };
    TopologicalEditorCollectionEditCtrl.prototype.getOppositeJoin = function (field) {
        for (var _i = 0, _a = this.matches; _i < _a.length; _i++) {
            var match = _a[_i];
            var join = match.getOppositeJoin(field.parent.instanceId, field.schema.id);
            if (join != null) {
                return join;
            }
        }
        return null;
    };
    TopologicalEditorCollectionEditCtrl.prototype.chooseLinkingCollection = function (field) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                page_state_1.CurrentState.CollectionLink.beginLinking(field.id);
                return [2 /*return*/, new Promise(function (resolve) {
                        var disposer = (0, mobx_1.reaction)(function () { return page_state_1.CurrentState.CollectionLink.isLinking; }, function () {
                            disposer();
                            var revision = page_state_1.CurrentState.CollectionLink.collectionRevision;
                            if (revision == null) {
                                resolve(null);
                            }
                            var collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
                            if (collectionSummary == null) {
                                resolve(null);
                            }
                            resolve(collectionSummary);
                        });
                    })];
            });
        });
    };
    TopologicalEditorCollectionEditCtrl.prototype.canInspectCollection = function (summary) {
        if (summary == null) {
            return false;
        }
        var tag = store_1.AppStore.Tag.get(summary.tags[0]);
        return services_1.Services.Search.includesTag(tag);
    };
    TopologicalEditorCollectionEditCtrl.prototype.inspectCollection = function (revision) {
        this.parentState.setSelectedCollectionRevision(revision);
    };
    TopologicalEditorCollectionEditCtrl.prototype.redrawMap = function () {
        this.parentState.map.overlay.resetMoveDelta();
    };
    Object.defineProperty(TopologicalEditorCollectionEditCtrl.prototype, "useColorCoding", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.observable.ref
    ], TopologicalEditorCollectionEditCtrl.prototype, "changeState", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorCollectionEditCtrl.prototype, "isAllExpanded", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorCollectionEditCtrl.prototype, "isInEditMode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorCollectionEditCtrl.prototype, "isSaving", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorCollectionEditCtrl.prototype, "isMetadataShown", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorCollectionEditCtrl.prototype, "isZoomShown", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorCollectionEditCtrl.prototype, "isPhotomeasure", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorCollectionEditCtrl.prototype, "isTopologicalEditor", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorCollectionEditCtrl.prototype, "isCarouselShown", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorCollectionEditCtrl.prototype, "isInUploadMode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], TopologicalEditorCollectionEditCtrl.prototype, "fieldsInLoadingState", void 0);
    tslib_1.__decorate([
        mobx_1.observable.shallow
    ], TopologicalEditorCollectionEditCtrl.prototype, "file", void 0);
    tslib_1.__decorate([
        mobx_1.observable.shallow
    ], TopologicalEditorCollectionEditCtrl.prototype, "image", void 0);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorCollectionEditCtrl.prototype, "zoomToCollection", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorCollectionEditCtrl.prototype, "clearOpenState", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorCollectionEditCtrl.prototype, "abortChanges", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorCollectionEditCtrl.prototype, "selectAnchorField", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorCollectionEditCtrl.prototype, "discardAndDestroyEdit", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorCollectionEditCtrl.prototype, "saveChanges", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorCollectionEditCtrl.prototype, "batchSaveChanges", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorCollectionEditCtrl.prototype, "setSaving", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorCollectionEditCtrl.prototype, "toggleFieldDetail", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorCollectionEditCtrl.prototype, "clearModalField", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorCollectionEditCtrl.prototype, "clearField", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorCollectionEditCtrl.prototype, "toggleCarousel", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorCollectionEditCtrl.prototype, "onDragOver", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorCollectionEditCtrl.prototype, "onDragLeave", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorCollectionEditCtrl.prototype, "onDragEnd", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorCollectionEditCtrl.prototype, "openImageDialog", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorCollectionEditCtrl.prototype, "openFileDialog", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorCollectionEditCtrl.prototype, "onImage", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorCollectionEditCtrl.prototype, "onFile", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorCollectionEditCtrl.prototype, "update", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorCollectionEditCtrl.prototype, "processFile", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorCollectionEditCtrl.prototype, "processImage", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorCollectionEditCtrl.prototype, "fileDownload", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorCollectionEditCtrl.prototype, "fillAddress", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorCollectionEditCtrl.prototype, "clearError", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorCollectionEditCtrl.prototype, "toggleExpanded", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorCollectionEditCtrl.prototype, "setZoomWindow", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorCollectionEditCtrl.prototype, "toggleMetaInfo", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorCollectionEditCtrl.prototype, "toggleZoomWindow", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorCollectionEditCtrl.prototype, "toggleExpandAll", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TopologicalEditorCollectionEditCtrl.prototype, "enterEditMode", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TopologicalEditorCollectionEditCtrl.prototype, "exitEditMode", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TopologicalEditorCollectionEditCtrl.prototype, "matches", null);
    return TopologicalEditorCollectionEditCtrl;
}(mobx_2.MobxState));
exports.TopologicalEditorCollectionEditCtrl = TopologicalEditorCollectionEditCtrl;
//# sourceMappingURL=topological.editor.collection.edit.ctrl.js.map